import { Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import useColors from "../../../../../api/hooks/useColors";
import {
  getTextFieldInputProps,
  StyledTextField,
  textFieldLabelProps,
} from "../../../../../components/forms/styles/formFieldStyles";

const AsanaNotes = () => {
  const colors = useColors();
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const notesLabel = useMemo(() => {
    const hasValue = values.notes?.trim();
    const labelText = hasValue ? "Task notes" : "Select task notes";

    return (
      <Box display="flex" alignItems="center" gap="4px">
        <Typography variant="caption">{labelText}</Typography>
      </Box>
    );
  }, [values.notes]);

  return (
    <StyledTextField
      margin="dense"
      id="asana-notes"
      label={notesLabel}
      fullWidth
      multiline
      minRows={4}
      maxRows={8}
      value={values.notes || ""}
      onChange={(event) => setFieldValue("notes", event.target.value)}
      error={!!touched.notes && !!errors.notes}
      helperText={
        touched.notes && typeof errors.notes === "string" ? errors.notes : ""
      }
      onBlur={handleBlur}
      InputProps={getTextFieldInputProps({
        sx: {
          padding: 1,
          "& textarea": {
            padding: "14px",
          },
        },
      })}
      InputLabelProps={textFieldLabelProps()}
      sx={{
        "& .MuiOutlinedInput-root": {
          backgroundColor: colors.textfield_outlined_enabled_auto_generated_bg,
        },
      }}
    />
  );
};
export default AsanaNotes;
